import { render, staticRenderFns } from "./TemplatePreviewListModal.vue?vue&type=template&id=8c892bec&scoped=true"
import script from "./TemplatePreviewListModal.vue?vue&type=script&lang=js"
export * from "./TemplatePreviewListModal.vue?vue&type=script&lang=js"
import style0 from "./TemplatePreviewListModal.vue?vue&type=style&index=0&id=8c892bec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c892bec",
  null
  
)

export default component.exports